import { UserPlusIcon } from '@heroicons/react/24/outline';
import { Modal } from '@components/ui';
import { CustomerForm } from '@features/customers/components/CustomerForm';
import { useCreateCustomer } from '@features/customers/hooks/useCustomers';
import type { Customer, CreateCustomerInput } from '@features/customers/types/customer.types';

interface CustomerFormModalProps {
  isOpen: boolean;
  onClose: () => void;
  onCustomerCreated?: (customer: Customer) => void;
}

export function CustomerFormModal({ isOpen, onClose, onCustomerCreated }: CustomerFormModalProps) {
  const createCustomerMutation = useCreateCustomer();

  const handleSubmit = async (data: CreateCustomerInput) => {
    try {
      const newCustomer = await createCustomerMutation.mutateAsync(data);
      if (onCustomerCreated) {
        onCustomerCreated(newCustomer);
      }
      onClose();
    } catch (error) {
      console.error('Error creating customer:', error);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      kicker="Facturación · Cliente"
      title="Crear Nuevo Cliente"
      description="El cliente queda disponible en el catálogo y se selecciona automáticamente en esta factura."
      icon={<UserPlusIcon />}
      size="xl"
      data-testid="invoice-wizard-customer-form-modal"
      closeTestId="invoice-wizard-customer-form-modal-close-button"
    >
      <CustomerForm
        onSubmit={handleSubmit}
        onCancel={onClose}
        isLoading={createCustomerMutation.isPending}
      />
    </Modal>
  );
}
